import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshanurbaniabuspackage() {



    const cardData =
    {
        keyword: 'Pune to Konkan Darshan Urbania Bus Package',
        heading: 'Urbania on rent in pune: Pune to Konkan Darshan Urbania Bus Package',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Pune to Konkan Darshan Urbania Bus Package for families, corporate groups, tourists, and event travelers planning comfortable and stylish travel to the scenic hill station of Mahabaleshwar. Our well-maintained luxury Force Urbania fleet provides spacious seating, powerful air-conditioning, plush interiors, and smooth performance, making it ideal for weekend getaways, corporate outings, airport transfers, weddings, sightseeing tours, and outstation journeys from Pune to Mahabaleshwar. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a refined, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for AC luxury Urbania hire to Mahabaleshwar.',

        top: 'Top Places to Visit in Konkan with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Ratnagiri",
    "description": "Ratnagiri is one of the most prominent destinations in the Konkan region, famous for its pristine beaches, historical forts, and world-renowned Alphonso mangoes. The city offers attractions like Ratnadurg Fort, Thibaw Palace, and beautiful coastal stretches such as Mandavi and Bhatye beaches. With a mix of history, culture, seafood cuisine, and scenic sea views, Ratnagiri perfectly represents the charm of Konkan’s coastal lifestyle."
  },
  {
    "title": "Ganpatipule",
    "description": "Ganpatipule is a serene beach town known for its clean white-sand beach and the famous Swayambhu Ganpati Temple located right by the sea. The calm waters, coconut groves, and uncrowded shoreline make it ideal for relaxation and spiritual tourism. The temple’s unique setting where devotees circumambulate the hill instead of the idol adds to its religious importance. Ganpatipule is a perfect blend of devotion and natural beauty."
  },
  {
    "title": "Tarkarli",
    "description": "Tarkarli is a coastal paradise in Konkan, best known for its crystal-clear waters, white sandy beaches, and water sports. It is one of the few places in Maharashtra offering snorkeling and scuba diving. The nearby Sindhudurg Fort, built by Chhatrapati Shivaji Maharaj, adds historical significance. Tarkarli is ideal for beach lovers, adventure seekers, and those wanting a peaceful seaside escape."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort is a majestic sea fort built by Chhatrapati Shivaji Maharaj near Malvan. Surrounded by the Arabian Sea, the fort showcases Maratha naval architecture and strategic brilliance. Visitors can explore massive stone walls, temples inside the fort, and footprints believed to belong to Shivaji Maharaj. The boat ride to the fort and panoramic sea views make it a must-visit historical attraction in Konkan."
  },
  {
    "title": "Malvan",
    "description": "Malvan is a culturally rich coastal town famous for Malvani cuisine, vibrant local markets, and scenic beaches. It serves as the gateway to Sindhudurg Fort and Tarkarli Beach. The town is known for spicy seafood dishes, coconut-based curries, and traditional Malvani hospitality. Malvan offers a raw and authentic Konkan experience with strong cultural roots."
  },
  {
    "title": "Dapoli",
    "description": "Dapoli is a peaceful hill station by the sea, often referred to as the ‘Mahabaleshwar of Konkan.’ It offers a pleasant climate, clean beaches like Murud and Karde, and lush greenery. Dapoli is ideal for families and nature lovers seeking quiet surroundings, scenic sunsets, and fresh coastal air away from crowded tourist hubs."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira is an unconquered sea fort located off the coast of Murud. Built by the Siddis, the fort stands strong amidst the sea and is known for its massive walls, secret passages, and freshwater lakes inside. The boat journey to the fort and its impressive architecture make it one of the most fascinating historical sites in the Konkan region."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a popular beach destination close to Mumbai, known for its clean beaches, water sports, and relaxed coastal vibe. Alibaug Beach, Kashid Beach, and Nagaon Beach attract tourists throughout the year. The Kolaba Fort, accessible during low tide, adds historical interest. Alibaug is perfect for weekend trips, beach holidays, and sea-facing resorts."
  },
  {
    "title": "Harihareshwar",
    "description": "Harihareshwar is a tranquil pilgrimage town known as the ‘Dakshin Kashi’ of Konkan. It is famous for the Harihareshwar Temple dedicated to Lord Shiva and its scenic beach surrounded by hills. The peaceful environment, clean shoreline, and spiritual significance make it ideal for devotees and travelers seeking calm and rejuvenation."
  },
  {
    "title": "Shrivardhan",
    "description": "Shrivardhan is a quiet coastal town known for its long, clean beach and historical connection to Peshwa Balaji Vishwanath. The destination offers serene beaches, fresh seafood, and cultural heritage sites. It is perfect for travelers looking to experience Konkan’s simplicity, natural beauty, and slow-paced coastal life."
  },
  {
    "title": "Guhagar",
    "description": "Guhagar is a hidden gem in Konkan featuring a long, untouched beach with soft white sand and calm waters. The town is also home to ancient temples and traditional Konkani culture. Guhagar is ideal for travelers who prefer peaceful, less commercialized beach destinations with authentic local experiences."
  },
  {
    "title": "Velneshwar",
    "description": "Velneshwar is a scenic beach village known for its tranquil atmosphere, coconut groves, and the ancient Shiva temple located near the shore. The calm and clean beach is ideal for relaxation, meditation, and long walks. Velneshwar remains largely untouched by mass tourism, making it perfect for a serene Konkan getaway."
  }
],






"services": [
{
"name": "Pune to Konkan Darshan Urbania Bus Package",
"description": "Pune to Konkan Darshan Urbania Bus Package offers a complete travel solution for exploring the scenic Konkan region. These well-maintained Urbania buses provide comfortable seating, professional chauffeurs, and a smooth journey from Pune to popular Konkan destinations, ensuring a hassle-free and memorable travel experience."
},
{
"name": "Konkan Darshan Urbania Hire from Pune",
"description": "Konkan Darshan Urbania Hire from Pune provides flexible rental options with AC and non-AC buses for family trips, corporate outings, and sightseeing tours. Designed for comfort and reliability, this service ensures a smooth journey while exploring the Konkan coast."
},
{
"name": "Urbania Bus Tour Package Konkan",
"description": "Urbania Bus Tour Package Konkan offers curated tour packages for visiting Konkan's beaches, forts, and scenic locations. Equipped with spacious seating and modern amenities, these buses provide a relaxing and enjoyable travel experience."
},
{
"name": "Pune Konkan Darshan Urbania Rental",
"description": "Pune Konkan Darshan Urbania Rental offers professional bus rental services for local and outstation travel to Konkan. Ideal for families, friends, and corporate groups, the service emphasizes comfort, safety, and timely pick-ups."
},
{
"name": "Urbania AC Bus Konkan Darshan",
"description": "Urbania AC Bus Konkan Darshan provides fully air-conditioned buses for a comfortable travel experience to the Konkan region. Perfect for long-distance journeys, sightseeing, and leisure trips with smooth ride and professional drivers."
},
{
"name": "Family Konkan Darshan Urbania Pune",
"description": "Family Konkan Darshan Urbania Pune caters to family groups looking for a comfortable, safe, and enjoyable Konkan tour. Features include spacious seating, luggage support, and courteous chauffeurs for a hassle-free experience."
},
{
"name": "Corporate Konkan Darshan Urbania Pune",
"description": "Corporate Konkan Darshan Urbania Pune provides professional transportation for company outings, team trips, and client tours along the Konkan route. Emphasizes punctuality, comfort, and a seamless corporate travel experience."
},
{
"name": "Luxury Urbania Konkan Tour",
"description": "Luxury Urbania Konkan Tour offers high-end air-conditioned buses with plush seating, modern interiors, and professional chauffeurs. Ideal for VIP travel, family vacations, and premium group tours across the Konkan region."
},
{
"name": "Affordable Konkan Darshan Urbania Pune",
"description": "Affordable Konkan Darshan Urbania Pune provides budget-friendly bus rental options without compromising on comfort, safety, or convenience. Perfect for groups seeking economical travel solutions to Konkan destinations."
},
{
"name": "Chauffeur Driven Urbania Konkan Tour",
"description": "Chauffeur Driven Urbania Konkan Tour ensures a safe and stress-free journey with verified, experienced drivers. Suitable for families, corporate groups, and tourists traveling along the scenic Konkan route."
},
{
"name": "Best Konkan Darshan Urbania Package Pune",
"description": "Best Konkan Darshan Urbania Package Pune offers top-rated buses with excellent service, clean interiors, punctual pick-ups, and comfortable travel. Ideal for local and outstation Konkan tours."
},
{
"name": "Group Travel Konkan Darshan Urbania",
"description": "Group Travel Konkan Darshan Urbania provides large-capacity buses for friends, families, and corporate groups. Ensures safe, comfortable, and convenient travel for organized group tours along the Konkan coastline."
},
{
"name": "Tourist Urbania Konkan Darshan",
"description": "Tourist Urbania Konkan Darshan offers premium buses for sightseeing and tourist travel. Features include comfortable seating, air-conditioning, and experienced drivers for a memorable Konkan Darshan experience."
},
{
"name": "Pune Konkan Darshan Bus Booking",
"description": "Pune Konkan Darshan Bus Booking provides easy and reliable booking options for Konkan trips from Pune. Ensures timely departure, well-maintained buses, and professional chauffeur services for hassle-free travel."
},
{
"name": "Trusted Konkan Darshan Urbania Service",
"description": "Trusted Konkan Darshan Urbania Service is known for safety, reliability, and exceptional service quality. Customers can rely on these Urbania buses for dependable, comfortable, and luxurious travel throughout the Konkan region."
}
],
"tableData": [
["Pune to Konkan Darshan Urbania Bus Package", "Konkan Darshan Urbania Hire from Pune"],
["Urbania Bus Tour Package Konkan", "Pune Konkan Darshan Urbania Rental"],
["Urbania AC Bus Konkan Darshan", "Family Konkan Darshan Urbania Pune"],
["Corporate Konkan Darshan Urbania Pune", "Luxury Urbania Konkan Tour"],
["Affordable Konkan Darshan Urbania Pune", "Chauffeur Driven Urbania Konkan Tour"],
["Best Konkan Darshan Urbania Package Pune", "Group Travel Konkan Darshan Urbania"],
["Tourist Urbania Konkan Darshan", "Pune Konkan Darshan Bus Booking"],
["Trusted Konkan Darshan Urbania Service", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Pune to Konkan Darshan Urbania Bus Package",
        "WhyChoosedescription": "Pune to Konkan Darshan Urbania Bus Package offers an ideal solution for group travel, family trips, corporate outings, and sightseeing tours, providing comfortable and spacious seating for a memorable journey."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Buses",
        "WhyChoosedescription": "The Pune to Konkan Darshan Urbania Bus Package includes modern Force Urbania buses with air-conditioning, ample legroom, reclining seats, and premium interiors for a relaxing travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our buses come with trained drivers familiar with Pune, Konkan region, and nearby routes, ensuring safe, punctual, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Pune to Konkan Darshan Urbania Bus Package for competitive rates with no hidden charges, making group travel cost-effective and enjoyable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "The package offers round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "The Pune to Konkan Darshan Urbania Bus Package can be customized for day trips, multi-day journeys, corporate tours, family outings, and sightseeing tours."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All buses in the Pune to Konkan Darshan Urbania Bus Package are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "We guarantee on-time pickups and dependable service, ensuring smooth and stress-free travel experiences from Pune to the Konkan region."
    }
]
}

const faqData = [
    {
        question: 'Is the Pune to Konkan Darshan Urbania Bus Package available for local and outstation travel?',
        answer: 'Yes, the package is designed for Pune to Konkan trips, including sightseeing tours, family outings, corporate trips, and group travel.',
    },
    {
        question: 'How can I book the Pune to Konkan Darshan Urbania Bus Package?',
        answer: 'You can book the package via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose the Pune to Konkan Darshan Urbania Bus Package?',
        answer: 'The package offers comfortable seating, professional drivers, clean buses, flexible itineraries, and transparent pricing for hassle-free travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for this package are licensed, trained, and familiar with Pune and Konkan routes for safe and timely travel.',
    },
    {
        question: 'Can pickup and drop-off locations be customized?',
        answer: 'Absolutely. The package allows flexible pickup and drop locations across Pune and nearby areas.',
    },
    {
        question: 'Is the Pune to Konkan Darshan Urbania Bus Package available 24x7?',
        answer: 'Yes, bookings and customer support are available 24x7 for your travel convenience.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'The package accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your Pune to Konkan journey for smooth and stress-free travel.',
    },
    {
        question: 'Is this package suitable for corporate, family, and group travel?',
        answer: 'Yes, the Pune to Konkan Darshan Urbania Bus Package is ideal for corporate outings, family trips, sightseeing tours, and group travel.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Suresh Patil',
        feedback: 'The Pune to Konkan Darshan Urbania Bus Package provided a comfortable and enjoyable trip for our family. Excellent service and well-maintained buses.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Deshmukh',
        feedback: 'We booked this package for a corporate outing. The bus was spacious, clean, and punctual. Highly recommended.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rahul Jadhav',
        feedback: 'Our Konkan trip was hassle-free and relaxing thanks to the Pune to Konkan Darshan Urbania Bus Package. Superb service!',
        rating: 5,
    },
];
































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Urbania Bus Package",
  "image": "https://urbaniaonrentpune.in/assets/images/konkan-darshan-urbania.jpg",
  "description": "Pune to Konkan Darshan Urbania Bus Package offers comfortable AC Urbania buses for Konkan sightseeing tours, family vacations, group travel, and corporate outings. Chauffeur-driven Urbania buses ensure a safe, convenient, and enjoyable Konkan Darshan tour experience from Pune to popular Konkan destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-konkan-darshan-urbania-bus-package"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Konkan Darshan Urbania Bus Package | AC Urbania Tour Bus 
  </title>

  <meta
    name="description"
    content="Book Pune to Konkan Darshan Urbania Bus Package for family tours, group travel, corporate outings, and tourist trips. AC Urbania buses with chauffeur-driven service provide a safe, comfortable, and memorable Konkan Darshan tour from Pune."
  />

  <meta
    name="keywords"
    content="Pune to Konkan Darshan Urbania Bus Package, Konkan Darshan Urbania Hire from Pune, Urbania Bus Tour Package Konkan, Pune Konkan Darshan Urbania Rental, Urbania AC Bus Konkan Darshan, Family Konkan Darshan Urbania Pune, Corporate Konkan Darshan Urbania Pune, Luxury Urbania Konkan Tour, Affordable Konkan Darshan Urbania Pune, Chauffeur Driven Urbania Konkan Tour, Best Konkan Darshan Urbania Package Pune, Group Travel Konkan Darshan Urbania, Tourist Urbania Konkan Darshan, Pune Konkan Darshan Bus Booking, Trusted Konkan Darshan Urbania Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokonkandarshanurbaniabuspackage;